__turbopack_context__.v({
  "className": "noto_sans_jp_65d50170-module__EdP5fG__className",
  "variable": "noto_sans_jp_65d50170-module__EdP5fG__variable",
});
